/**
 * Returns a set of log messages for use in a similar location. Logged messages have a unique prefix and style.
 */
export const logPack = (prefix: string) => {
    return {
        log: (msg: string, ...args: any[]) => console.log(`${prefix}${msg}`, ...args),
        success: (msg: string, ...args: any[]) => console.log(`%c${prefix}${msg}`, 'color:green', ...args),
        error: (msg: string, ...args: any[]) => console.log(`%c${prefix}${msg}`, 'color:red', ...args),
        warn: (msg: string, ...args: any[]) => console.log(`%c${prefix}${msg}`, 'color:yellow', ...args),
        info: (msg: string, ...args: any[]) => console.log(`%c${prefix}${msg}`, 'color:fuchsia', ...args),
    };
};
